var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('data-iterator',{staticClass:"ma-2",attrs:{"headers":_vm.payloadHeaders,"payload":_vm.payload}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }